import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class StickyAddToCart extends HTMLElement {
  #unsubscribe;

  connectedCallback() {
    this.#observeProductForm();

    this.#unsubscribe = PubSub.subscribe('variant:change', ({ id, data: { html } }) => {
      if (id !== this.dataset.productId) return;
      this.#handleVariantChange(html);
      this.#observeProductForm();
    });
  }

  disconnectedCallback() {
    this.#unsubscribe();
  }

  /**
   * Handle variant changes.
   * @param {HTMLElement} html - The HTML to render.
   */
  #handleVariantChange(html) {
    const stickyAddToCart = html.querySelector('sticky-add-to-cart');
    this.innerHTML = stickyAddToCart.innerHTML;
  }

  /**
   * Observe the product form.
   */
  #observeProductForm() {
    const addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');
    if (!addToCartForm) return;

    const observer = new IntersectionObserver(([{ isIntersecting, boundingClientRect }]) => {
      const scrolledPast = !isIntersecting && boundingClientRect.bottom < 0;

      this.classList.toggle('translate-y-0', scrolledPast);
      this.classList.toggle('translate-y-full', !scrolledPast);
      this.classList.toggle('opacity-0', !scrolledPast);
    });

    observer.observe(addToCartForm);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
